import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { Provider } from 'react-redux'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { store } from '@/store'
import { initSentry } from '@/lib/sentry'
import { PlatformSettingsProvider } from '@/contexts/PlatformSettingsContext'
import '@/i18n'
import './index.css'
import App from './App.jsx'

initSentry();



const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    {/* ErrorBoundary catches React render errors + shows fallback instead of blank screen */}
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ padding: 40, fontFamily: 'sans-serif', textAlign: 'center' }}>
          <h2>حصل خطأ غير متوقع</h2>
          <p style={{ color: '#666', marginBottom: 16 }}>{String(error)}</p>
          <button onClick={resetError} style={{ padding: '8px 20px', cursor: 'pointer' }}>
            إعادة المحاولة
          </button>
        </div>
      )}
      showDialog
    >
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <PlatformSettingsProvider>
            <App />
          </PlatformSettingsProvider>
        </QueryClientProvider>
      </Provider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
